exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".update-form .v-input__control {\n  min-height: 42px !important;\n}\n.update-form .v-input__slot {\n  margin-bottom: 2px;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n  border: 1px solid transparent;\n  background-color: #eee !important;\n  border-radius: 10px !important;\n}\n.update-form .v-text-field__details {\n  margin-bottom: 0 !important;\n}\n.update-form .error--text .v-input__slot {\n  border: 1px solid #ff5252 !important;\n}", ""]);

// exports
